<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fade-in p-4 font-prompt">
  <!-- Modal card frame -->
  <div class="bg-white rounded-[2rem] w-full max-w-sm p-6 shadow-2xl flex flex-col text-left animate-scale-up relative">

    <!-- Close cross button -->
    <button (click)="close.emit()"
      class="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition-all active:scale-90 outline-none">
      <img src="icons/close_slate_dark.svg" />
    </button>

    <!-- Header label -->
    <h2 class="text-sm font-bold text-gray-800 mb-4 pr-8">
      {{ currentLang === 'TH' ? 'แชร์รถยนต์ร่วมกัน' : 'Share Vehicle' }}
    </h2>

    <div class="space-y-4">
      <!-- Search input section -->
      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLang === 'TH' ? 'ค้นหาผู้รับคำเชิญ (เบอร์โทรศัพท์)' : 'Search Invitee (Phone)' }}
        </label>
        <div class="flex gap-2">
          <input type="text" [(ngModel)]="searchQuery" (input)="onSearchInput($event)" placeholder="08xxxxxxxx"
            class="flex-1 bg-gray-50/50 border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
          <button (click)="searchUser()"
            class="bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold px-4 py-2 rounded-xl active:scale-95 transition-all outline-none">
            {{ currentLang === 'TH' ? 'ค้นหา' : 'Search' }}
          </button>
        </div>
      </div>

      <!-- Loading loader indicator -->
      <div *ngIf="isLoading" class="flex justify-center items-center py-4">
        <img src="icons/sync_orange.svg" />
      </div>

      <!-- Found user & Vehicle selector section -->
      <div *ngIf="foundUser"
        class="space-y-3 p-4 bg-amber-50/30 border border-amber-100/50 rounded-2xl animate-fade-in">
        <div>
          <span class="text-[9px] text-gray-400 block font-bold leading-none">{{ currentLang === 'TH' ? 'ผู้ใช้งานที่พบ'
            : 'Matched User' }}</span>
          <span class="text-xs font-bold text-gray-800 mt-1 block">{{ foundUser.name }} ({{ foundUser.phone }})</span>
        </div>

        <!-- Custom autocomplete select dropdown for choosing own vehicle to share -->
        <div class="relative">
          <label class="block font-bold text-[10px] text-gray-600 mb-1.5">
            {{ currentLang === 'TH' ? 'เลือกทะเบียนรถที่จะแชร์' : 'Choose Vehicle to Share' }}
          </label>
          <div class="relative">
            <input type="text" [(ngModel)]="vehicleSearchText" (focus)="openVehicleDropdown()"
              (blur)="closeVehicleDropdown()"
              placeholder="{{ currentLang === 'TH' ? 'พิมพ์ค้นหาทะเบียน...' : 'Search plate number...' }}"
              class="w-full bg-white border border-gray-200 text-xs rounded-xl px-3 py-2 text-gray-800 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer" />
            <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition dulation"
              [class.rotate-180]="activeVehicleDropdown">
              <img src="icons/expand_more_slate_dark.svg" />
            </div>
          </div>

          <!-- Dropdown List options -->
          <div *ngIf="activeVehicleDropdown" (mousedown)="$event.preventDefault()"
            class="absolute z-50 left-0 right-0 mt-1 max-h-36 overflow-y-auto bg-white border border-gray-100 rounded-xl shadow-lg scroll-smooth py-1">
            <div *ngFor="let v of filteredVehicleOptions" (click)="selectVehicleOption(v)"
              class="px-4 py-2 text-xs text-gray-700 hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-colors">
              {{ v.name }}
            </div>
            <div *ngIf="filteredVehicleOptions.length === 0" class="px-4 py-2 text-xs text-gray-400 text-center">
              {{ currentLang === 'TH' ? 'ไม่พบข้อมูลทะเบียน' : 'No matches found' }}
            </div>
          </div>
        </div>

        <!-- Submit button -->
        <button (click)="sendShareInvite()"
          class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-xs font-bold rounded-xl py-2.5 shadow-md active:scale-95 transition-all outline-none mt-2">
          {{ currentLang === 'TH' ? 'ส่งคำเชิญแชร์สิทธิ์' : 'Confirm & Share' }}
        </button>
      </div>
    </div>
  </div>
</div>